import React from "react";
import PropTypes from "prop-types";
import { TextField,InputAdornment, Typography} from "@mui/material";
import { useField, useFormikContext, ErrorMessage } from "formik";
import FormikLabel from "./FormikLabel";
import { ErrorStyle } from "./ErrorStyle";
import { AddIcon } from "@/icons";

const FormikNumberInput = ({
  name,
  label,
  width = "100%",
  required = false,
  placeholder = "Enter a number",
  disabled = false,
  readOnly = false,
  extraText,
  icons = false,
  maxLength, // Add maxLength prop
  onChange = () => {},
  inputRestriction = "text",
  ...props
}) => {
  const [field] = useField(name);
  const { setFieldValue } = useFormikContext();
  const isNumeric = inputRestriction === "numeric";
  const inputType = isNumeric ? "number" : "text";
  return (
    <div style={{ width }}>
      <FormikLabel text={label} required={required} />
      <TextField
        {...field}
        type={inputType}
        {...props}
        placeholder={placeholder}
        fullWidth
        disabled={disabled}
        inputProps={{
          readOnly,
          inputMode: "numeric",
          pattern: "[0-9]*\\.?[0-9]+",
          maxLength, // Apply maxLength if needed
          style: {
            appearance: "none",
            MozAppearance: "textfield",
            WebkitAppearance: "none",
          },
        }}
        InputProps={{
          startAdornment: icons ? (
            <InputAdornment position="start">{icons}</InputAdornment>
          ) : null,
        }}
        onChange={(e) => {
          if (!readOnly) {
            const value = e.target.value.replace(/<[^>]*>/g, "");
            // Restrict length
            if (!maxLength || value.length <= maxLength) {
              setFieldValue(name, value);
              onChange({ ...e, target: { ...e.target, value } });
            }
          }
        }}
        onWheel={(e) => e.target.blur()}
        sx={{
          ...props.sx,
          "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
          },
          "& input[type=number]": {
            MozAppearance: "textfield",
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            borderWidth: "1px",
          },
          "& .MuiInputBase-input": {
            backgroundColor: disabled || readOnly ? "#f5f5f5" : "inherit",
            padding: "8px",
          },
        }}
      />
      {extraText &&(
        <div>
        <Typography variant="subtitle2" sx={{fontWeight:800}}>{extraText}</Typography>
        </div>
      )}
     
      <div style={ErrorStyle}>
        <ErrorMessage name={name} />
      </div>
    </div>
  );
};

// PropTypes for validation
FormikNumberInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  width: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  maxLength: PropTypes.number, // Add maxLength validation
  onChange: PropTypes.func,
  extraText: PropTypes.string,
};

export default FormikNumberInput;

